import { List, Misc, ModalUtils, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";
import { AppService, DomainTypes, Types } from '../../../DomainTypes';
import Entity from "../../../Models/Catalogue/Investments/Entity";
import BankDetail from '../../../Models/ValueObjects/BankDetail';

@NeoModel
export default class EntityVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        protected investmentApiClient = AppService.get(DomainTypes.ApiClients.CatalogueInvestment),
        private dataCache = AppService.get(DomainTypes.Services.DataCache),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public imagesApiClient = AppService.get(DomainTypes.ApiClients.ImagesApiClient),
        public documentApiClient = AppService.get(DomainTypes.ApiClients.Documents)) {

        super(taskRunner);
    }

    public entityList = new List(Entity);
    public editingEntity: Entity | null = null;

    public async initialise() {
        const response = await this.taskRunner.waitFor(this.investmentApiClient.getEntities());
        this.entityList.set(response.data);
    }

    public async deleteEntities(entityId: Entity) {
        if (await ModalUtils.showYesNo("Delete", "Are you sure you want to delete this item?") === Misc.ModalResult.Yes) {
            this.taskRunner.run(async () => {
                this.entityList.remove(entityId);
                this.saveEntities(true);
                this.notifications.addSuccess("Delete Successful", "Entities were deleted successfully.", NotificationDuration.Standard);
            });
        }
    }

    public editEntities(item: Entity) {
        this.editingEntity = item;
    }

    public newEntity() {
        this.editingEntity = new Entity;
    }

    public saveEntities(isDelete: boolean = false) {
        if (!isDelete) {
            if (this.editingEntity!.isNew) {
                this.entityList.push(this.editingEntity!);
            }
        }
        this.taskRunner.run(async () => {
            const response = await this.investmentApiClient.saveEntities(this.entityList.toJSArray())
            this.entityList.update(response.data);
            this.dataCache.entities.expire();
            if (!isDelete) {
                this.notifications.addSuccess("Save Successful", "Entities were saved successfully.", NotificationDuration.Standard);
            }
        });
    }

    public toggleBankDetails() {
        if (this.editingEntity) {
            if (!this.editingEntity.bankDetails) {
                this.editingEntity.bankDetails = new BankDetail();
            } else {
                this.editingEntity!.bankDetails = null;
            }
        }
    }
}